import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import { UserFieldsFragmentDoc } from '../../../fragments/userFields.generated';
import { HistoryFieldsFragmentDoc } from '../../../fragments/historyFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetParagraphDetailsQueryVariables = Types.Exact<{
  regulatoryDocumentId: Types.Scalars['ID'];
  paragraphId: Types.Scalars['ID'];
}>;


export type GetParagraphDetailsQuery = { __typename?: 'Query', regulatoryDocumentParagraph: { __typename?: 'RegulatoryDocumentParagraph', page: number, level: number, id: string, enumeration: string, isFootnote: boolean, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, createdAt?: any | null, modifiedAt?: any | null, parent: { __typename?: 'RegulatoryDocument', name: string, regulation?: { __typename?: 'Regulation', regulationNumber: string } | null, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus, message?: string | null } }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string } | null }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, definition?: string | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, faqs?: Array<{ __typename?: 'Faq', id: string, question?: string | null, answer?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, auditLog: Array<{ __typename: 'AuditLog', entityId: string, entityNodeId: string, changeSetId: any, entityType: string, entityOperation: Types.EntityOperation, createdAt: any, id: string, entity?: { __typename: 'ActiveTypeMarket', id: string } | { __typename: 'AttachmentCategory', id: string } | { __typename: 'AuditLog', id: string } | { __typename: 'BodyworkVariant', id: string } | { __typename: 'Category', id: string } | { __typename: 'Convolute', id: string } | { __typename: 'Country', id: string } | { __typename: 'DocumentSource', id: string } | { __typename: 'DriveVariant', id: string } | { __typename: 'EngineVariant', id: string } | { __typename: 'GdprRule', id: string } | { __typename: 'GearboxVariant', id: string } | { __typename: 'GetexRegulation', id: string } | { __typename: 'GlobalAnnouncement', id: string } | { __typename: 'IcsCode', id: string } | { __typename: 'Keyword', id: string } | { __typename: 'Market', id: string } | { __typename: 'PermissionGroup', id: string } | { __typename: 'PogisDocument', id: string } | { __typename: 'Question', id: string } | { __typename: 'QuestionCategory', id: string } | { __typename: 'Reference', id: string } | { __typename: 'Regulation', id: string } | { __typename: 'RegulationCluster', id: string } | { __typename: 'RegulatoryDocument', id: string } | { __typename: 'Requirement', id: string } | { __typename: 'Simulation', id: string } | { __typename: 'SimulationVehicleProject', id: string } | { __typename: 'StandardPlusPcmsCluster', id: string } | { __typename: 'Subscription', id: string } | { __typename: 'SystemLevel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'User', id: string } | { __typename: 'VehicleCategory', id: string } | { __typename: 'VehicleProject', id: string } | { __typename: 'VexCluster', id: string } | { __typename: 'Vko', id: string } | null, change: { __typename: 'AuditLogChange', value?: any | null, oldValue?: any | null, nodeId?: string | null, oldNodeId?: string | null, type: string, key: string, path: string, valueType?: string | null }, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> } };


export const GetParagraphDetailsDocument = gql`
    query GetParagraphDetails($regulatoryDocumentId: ID!, $paragraphId: ID!) {
  regulatoryDocumentParagraph(
    regulatoryDocumentId: $regulatoryDocumentId
    paragraphId: $paragraphId
  ) {
    page
    level
    id
    enumeration
    isFootnote
    modelYear
    comprehensive
    dateNewRegistration
    dateNewTypes
    summary
    parent {
      name
      regulation {
        regulationNumber
      }
      workflow {
        status
        message
      }
    }
    createdAt
    createdBy {
      givenName
      id
      mail
      name
      surname
      userPrincipalName
    }
    modifiedAt
    modifiedBy {
      givenName
      id
      mail
      name
      surname
      userPrincipalName
    }
    driveVariants {
      id
      name
    }
    keywords {
      id
      name
    }
    vehicleCategories {
      id
      name
    }
    categories {
      id
      name
    }
    tags {
      id
      name
    }
    elements {
      type
      asset {
        uri
        contentType
        fileName
      }
      text
      isHeader
      page
      bounds
      textPosition
    }
    phaseIn {
      date
      status
    }
    phaseOut {
      date
      status
    }
    requirements {
      id
      name
      requirementId
      status
      definition
    }
    attachments {
      ...AttachmentFields
    }
    comments {
      id
      comment
      createdAt
      createdBy {
        ...UserFields
      }
      modifiedAt
      modifiedBy {
        ...UserFields
      }
    }
    faqs {
      id
      question
      answer
      createdAt
      createdBy {
        ...UserFields
      }
      modifiedAt
      modifiedBy {
        ...UserFields
      }
    }
    auditLog {
      ...HistoryFields
    }
  }
}
    ${AttachmentFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${HistoryFieldsFragmentDoc}`;

/**
 * __useGetParagraphDetailsQuery__
 *
 * To run a query within a React component, call `useGetParagraphDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParagraphDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParagraphDetailsQuery({
 *   variables: {
 *      regulatoryDocumentId: // value for 'regulatoryDocumentId'
 *      paragraphId: // value for 'paragraphId'
 *   },
 * });
 */
export function useGetParagraphDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetParagraphDetailsQuery, GetParagraphDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParagraphDetailsQuery, GetParagraphDetailsQueryVariables>(GetParagraphDetailsDocument, options);
      }
export function useGetParagraphDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParagraphDetailsQuery, GetParagraphDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParagraphDetailsQuery, GetParagraphDetailsQueryVariables>(GetParagraphDetailsDocument, options);
        }
export type GetParagraphDetailsQueryHookResult = ReturnType<typeof useGetParagraphDetailsQuery>;
export type GetParagraphDetailsLazyQueryHookResult = ReturnType<typeof useGetParagraphDetailsLazyQuery>;
export type GetParagraphDetailsQueryResult = Apollo.QueryResult<GetParagraphDetailsQuery, GetParagraphDetailsQueryVariables>;